import { Trans } from '@lingui/macro'
import cx from 'classnames'

import styles from './Menu.module.scss'
import Tab from './Tab'
import Text from '../../typography/Text'
import AccountLogoutIcon from '../icons/AccountLogoutIcon'

export interface Props extends React.HTMLAttributes<HTMLElement> {
    baseUrl: string
}

const LogoutMenuItem = ({ baseUrl, className }: Props) => (
    <Tab
        className={cx(styles.logout, styles.menuItem, className)}
        name="Logout"
        icon={<AccountLogoutIcon />}
        to={`${baseUrl}/logout`}
    >
        <Text>
            <Trans id="account.menu.logout">Logout</Trans>
        </Text>
    </Tab>
)

export default LogoutMenuItem
